import type { ConstValues } from '@openx/types/helpers.ts';

export const dataType = {
  EMAIL: 'email',
  MOBILE_AD_ID: 'maid',
  PHONE: 'phone',
} as const;
export type DataType = ConstValues<typeof dataType>;

export const uploadFileSummaryStatus = {
  FAILED: 'failed',
  SUCCESS: 'success',
} as const;
export type UploadFileSummaryStatus = ConstValues<typeof uploadFileSummaryStatus>;

export interface UploadFileProgressProps {
  recordsProcessed: number;
  progress: number;
}

export interface UploadFileSuccessSummaryProps {
  status: 'success';
  dataType: DataType;
  recordsProcessed: number;
  recordsFailed: number;
}
